import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthService {

  // baseUrl = 'http://18.194.142.198:3340/'; /**online */
  // baseUrl = 'http://192.168.1.44:2222/'; /**local */
  // baseUrl = 'http://103.121.26.82:1452/'; /*for build */
  baseUrl = 'https://api.ticketvoordeel.nl/'; /*for build */

  constructor(private _http: HttpClient) { }

  getAuthToken() {
    const requestObject = {'username': 'test', 'password': 'test'};
    this._http.post(this.baseUrl + 'users/authenticate', requestObject).subscribe((response: any) => {
      this.storeAuthToken(response.token);
    });
  }

  storeAuthToken(token) {
    localStorage.setItem('authToken', token);
  }

  getToken() {
    return (localStorage.getItem('authToken'));
  }

}
